var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row mt-4" }, [
      _c("div", { staticClass: "col-12 col-lg-6" }, [
        _c(
          "h5",
          {
            staticClass:
              "font-weight-bold text-lowercase patcraft-text-underline",
            attrs: {
              "data-text": _vm.headerData.inventoryType
                ? _vm.headerData.inventoryType.slice(0, 3)
                : ""
            }
          },
          [
            _vm._v(
              "\n        " + _vm._s(_vm.headerData.inventoryType) + "\n      "
            )
          ]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row mt-4" }, [
      _c("div", { staticClass: "col-12 col-lg-6" }, [
        _c("h3", { staticClass: "font-weight-bold text-uppercase" }, [
          _vm._v(_vm._s(_vm.headerData.productTypeDesc))
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }